import React, { useEffect, useState } from 'react';
import API from '../../../../services/API';
import { Button, message, Modal } from 'antd';
import { convertCentsIntoDollar } from "../../../../helpers/genericHelper";
import CustomText from "../../../CustomText";

const UpdateSubscriptionModal = ({ userId, activeSubscriptionId, onClose, refreshList }) => {
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [invoicePreview, setInvoicePreview] = useState(null);
    const [subscriptionPlans, setSubscriptionPlans] = useState(null);
    const [loading, setLoading] = useState(false);
    const successMessage = (content, duration = 5) => {
        message.success(content, duration);
    };

    const errorMessage = (content, duration = 10) => {
        message.error(content, duration);
    };

    useEffect(() => {
        const fetchSubscriptionPlans = async () => {
            try {
                setLoading(true);
                const response = await API.getSubscriptionPlans();
                setSubscriptionPlans(response.subscriptionPlans);
            } catch (error) {
                errorMessage('Failed to fetch subscription plans.');
            } finally {
                setLoading(false);
            }
        };

        fetchSubscriptionPlans();
    }, []);

    const previewInvoiceUpdatedSubscription = async () => {
        if (selectedPlan) {
            try {
                setLoading(true);
                const response = await API.previewInvoiceUpdatedSubscription(userId, activeSubscriptionId, selectedPlan.id);
                setInvoicePreview(response);
                successMessage('Successfully fetched the invoice for the updated subscription.');
            } catch (error) {
                errorMessage(error?.response?.data?.error_message || error?.response?.data?.errorMessage);
            } finally {
                setLoading(false);
            }
        }
    };

    const updateSubscription = async () => {
        try {
            setLoading(true);
            await API.updateSubscription(userId, selectedPlan.id);
            successMessage('Successfully updated the subscription plan.');
            onClose();
        } catch (error) {
            errorMessage(error?.response?.data?.error_message || error?.response?.data?.errorMessage);
        } finally {
            setLoading(false);
            refreshList();
        }
    };

    return (
        <Modal
            title="Update Subscription Plan" 
            onCancel={onClose}
            open={true}
            footer={
                <em>
                Only use this if you you want to <strong>DOWNGRADE</strong> the subscription plan.
                Use Check Offers for upgrade offers and cancellation offers.
                </em>}
            >
            {subscriptionPlans ? (
                <div>
                    <h3>Select a Plan:</h3>
                    {subscriptionPlans.map((plan) => (
                        <div key={plan.id}>
                            <input
                                type="radio"
                                name="subscriptionPlan"
                                id={plan.id}
                                onChange={() => setSelectedPlan(plan)}
                            />
                            <span>&ensp;</span>
                            <CustomText dataSet={plan} property1={'interval'}/>
                            <span>:&ensp;</span>
                            <CustomText dataSet={plan} property1={'priceCents'} formatter={convertCentsIntoDollar} />
                        </div>
                    ))}
                    <br/>
                    <div>
                        <Button type="primary" onClick={previewInvoiceUpdatedSubscription} disabled={!selectedPlan || loading}>
                            Preview Invoice
                        </Button>
                    </div>
                </div>
            ) : (
                <p>Loading subscription plans...</p>
            )}

            {invoicePreview && (
                <>
                    <div className="ant-list-box table-responsive" style={{ maxHeight: 400 }}>
                        <table className="width-100" style={{ textAlign: 'center' }}>
                            <thead>
                            <tr>
                                <th style={{ textAlign: 'center' }}>Due Date</th>
                                <th style={{ textAlign: 'center' }}>Subtotal</th>
                                <th style={{ textAlign: 'center' }}>Tax</th>
                                <th style={{ textAlign: 'center' }}>Total</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td style={{ textAlign: 'center' }}>
                                    {invoicePreview.dueDate ? (
                                        <CustomText dataSet={invoicePreview} property1={'dueDate'} />
                                    ) : (
                                        <span>{'N/A'}</span>
                                    )}
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                    <CustomText dataSet={invoicePreview} property1={'subtotalInCents'} formatter={convertCentsIntoDollar} />
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                    <CustomText dataSet={invoicePreview} property1={'taxInCents'} formatter={convertCentsIntoDollar} />
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                    <CustomText dataSet={invoicePreview} property1={'totalInCents'} formatter={convertCentsIntoDollar} />
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <Button type="primary" onClick={updateSubscription} disabled={loading}>
                        Confirm
                    </Button>
                    <Button onClick={onClose} disabled={loading}>
                        Cancel
                    </Button>
                </>
            )}
        </Modal>
    );
};

export default UpdateSubscriptionModal;